module.exports = __webpack_public_path__ + "loading.042398475f252c51a77e.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/assets/images/bds/new_set/small/loading.svg
// module id = ../../../../../src/assets/images/bds/new_set/small/loading.svg
// module chunks = 11